var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink4Um(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9998C0 7.16337 7.16337 0 15.9998 0C24.8363 0 31.9997 7.16337 31.9997 15.9998C31.9997 24.8363 24.8363 31.9997 15.9998 31.9997C7.16337 31.9997 0 24.8363 0 15.9998Z",
    fill: "#028383"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 16.6666C14.9465 17.0494 15.3117 17.3661 15.7312 17.5952C16.1506 17.8244 16.6145 17.9607 17.0912 17.9948C17.568 18.029 18.0465 17.9602 18.4943 17.7931C18.9422 17.6261 19.3488 17.3647 19.6868 17.0266L21.6867 15.0267C22.2939 14.398 22.6299 13.556 22.6223 12.682C22.6147 11.808 22.2642 10.972 21.6461 10.354C21.0281 9.73596 20.1921 9.38541 19.3181 9.37781C18.4441 9.37022 17.6021 9.70619 16.9735 10.3134L15.8268 11.4534",
    stroke: "white",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3265 15.3333C17.0402 14.9506 16.675 14.6339 16.2555 14.4047C15.8361 14.1755 15.3722 14.0392 14.8955 14.0051C14.4187 13.971 13.9402 14.0397 13.4923 14.2068C13.0445 14.3739 12.6378 14.6353 12.2999 14.9733L10.3 16.9733C9.69277 17.6019 9.35679 18.4439 9.36438 19.3179C9.37198 20.1919 9.72254 21.0279 10.3406 21.646C10.9586 22.264 11.7946 22.6145 12.6686 22.6221C13.5426 22.6297 14.3846 22.2937 15.0132 21.6866L16.1532 20.5466",
    stroke: "white",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9998,
    height: 15.9998,
    fill: "white",
    transform: "translate(7.99316 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink4Um);
export default __webpack_public_path__ + "static/media/link4um.9b621c790c455259d12c86cd91402ce1.svg";
export { ForwardRef as ReactComponent };